module.exports = __webpack_public_path__ + "img/ic_analytic_wh.80d9e86c.svg";